/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AppVersionContentItemDto } from './AppVersionContentItemDto';
import {
    AppVersionContentItemDtoFromJSON,
    AppVersionContentItemDtoFromJSONTyped,
    AppVersionContentItemDtoToJSON,
    AppVersionContentItemDtoToJSONTyped,
} from './AppVersionContentItemDto';

/**
 * 
 * @export
 * @interface AppVersionCheckResponseDto
 */
export interface AppVersionCheckResponseDto {
    /**
     * True when the provided version is older than latest active version
     * @type {boolean}
     * @memberof AppVersionCheckResponseDto
     */
    isUpdate: boolean;
    /**
     * Latest active version configured in the backend, or the provided version when no active version exists
     * @type {string}
     * @memberof AppVersionCheckResponseDto
     */
    versionLatest: string;
    /**
     * 
     * @type {Array<AppVersionContentItemDto>}
     * @memberof AppVersionCheckResponseDto
     */
    contentUpdate: Array<AppVersionContentItemDto>;
}

/**
 * Check if a given object implements the AppVersionCheckResponseDto interface.
 */
export function instanceOfAppVersionCheckResponseDto(value: object): value is AppVersionCheckResponseDto {
    if (!('isUpdate' in value) || value['isUpdate'] === undefined) return false;
    if (!('versionLatest' in value) || value['versionLatest'] === undefined) return false;
    if (!('contentUpdate' in value) || value['contentUpdate'] === undefined) return false;
    return true;
}

export function AppVersionCheckResponseDtoFromJSON(json: any): AppVersionCheckResponseDto {
    return AppVersionCheckResponseDtoFromJSONTyped(json, false);
}

export function AppVersionCheckResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppVersionCheckResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'isUpdate': json['isUpdate'],
        'versionLatest': json['versionLatest'],
        'contentUpdate': ((json['contentUpdate'] as Array<any>).map(AppVersionContentItemDtoFromJSON)),
    };
}

export function AppVersionCheckResponseDtoToJSON(json: any): AppVersionCheckResponseDto {
    return AppVersionCheckResponseDtoToJSONTyped(json, false);
}

export function AppVersionCheckResponseDtoToJSONTyped(value?: AppVersionCheckResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isUpdate': value['isUpdate'],
        'versionLatest': value['versionLatest'],
        'contentUpdate': ((value['contentUpdate'] as Array<any>).map(AppVersionContentItemDtoToJSON)),
    };
}

